import React, {useEffect, useState, useRef} from "react";
import GenStyles from "./styles/GenStyles.module.css";
import { talk } from "./ALI_Ajax.js";
import TStyles from "./styles/TestStyles.module.css";
import {useUser} from "./UserContext";
import LoginModule from "./login_module";
import STTStyles from "./styles/STTStyles.module.css";
import {ALI_Recorder} from "./ALI_Recorder.js";
import aiAnimationTransparent from "./images/ai_speaker_image_transparent.png";
import SpeakingTestInterface from "./components/SpeakingTestInterface";
import JsonViewer from "./components/JsonViewer";



const TakeTestOld = (props) => {
    const {userId, finishedLoggingIn} = useUser();
    const [responseText, setResponseText] = useState(false);
    const [audioUrl, setAudioUrl] = useState(false);
    const [studentTextResponse, setStudentTextResponse] = useState('');
    const [isRecording, setIsRecording] = useState(false);
    const [recordingUrl, setRecordingUrl] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [questionTotalTime, setQuestionTotalTime] = useState(30);
    const [questionTimeRemaining, setQuestionTimeRemaining] = useState(30);
    const [timeRemaining, setTimeRemaining] = useState(null);
    const [testState, setTestState] = useState(null);
    console.log("Recovering From AI Error");
    const rubric = {
        "skills": {
            "grammar": {
                "present_tense": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "past_tense": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "present_continuous": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "present_perfect": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "future_tense": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "past_perfect": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "present_perfect_continuous": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "past_perfect_continuous": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "past_continuous": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "future_continuous": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "future_perfect": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "future_perfect_continuous": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "singular_plural_noncount_nouns": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "pronoun_usage": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                },
                "subject_verb_agreement": {
                    "ai_rating": null,
                    "ai_justification": null,
                    "human_final_rating": null
                }
            },
            "fluency": {
                "ai_rating": null,
                "ai_justification": null,
                "human_final_rating": null
            },
            "vocabulary": {
                "ai_rating": null,
                "ai_justification": null,
                "human_final_rating": null
            }
        },
        "summary": {
            "overall_ai_rating": null,
            "overall_ai_justification": null,
            "human_final_rating": null
        }
    }




    //USE EFFECTS

    //Don't know what this one does
    useEffect(() => {
        //console.log(recordingUrl);
        if(recordingUrl) {
            speech_to_text();
        }
    }, [recordingUrl])

    //On Load... Create Event Listeners
    useEffect(() => {
        const handleRecordingStarted = () => {
            //console.log("Recording started event received!");
            setIsRecording(true);
            setNotificationMessage("Recording: ");
        };
        const handleRecordingStopped = (event) => {
            //console.log("Recording has stopped. Audio URL: ", event.detail.audioURL);
            setRecordingUrl(ALI_Recorder.processRecording());
            setIsRecording(false)
            setTestState('thinking');
            setNotificationMessage("Processing");
        }
        const handleRecordingTick = (event) => {
            //console.log("Timer Tick");
            setNotificationMessage("Recording: " + questionTimeRemaining);
            setQuestionTimeRemaining(event.detail.timeRemaining);
        }


        document.addEventListener("recordingTick", handleRecordingTick);
        document.addEventListener("recordingStarted", handleRecordingStarted);
        document.addEventListener("recordingStopped", handleRecordingStopped);

        return () => {
            document.removeEventListener("recordingTick", handleRecordingTick);
            document.removeEventListener("recordingStarted", handleRecordingStarted);
            document.removeEventListener("recordingStopped", handleRecordingStopped);
        }
    }, []);

    //Does Nothing... delete in the future?
    useEffect(() => {

    }, [userId]);

    //Start playing audio if an audio URL is Supplied
    useEffect(() => {
        if(audioUrl) {
            //console.log(audioUrl);
            let player = document.getElementById('audio_player');
            player.src = audioUrl;
            player.play();
            setTestState('speaking');
        }
    }, [audioUrl])

    //Handle Question Timing and Passing Data to Interface to Show Progress Bar
    useEffect(() => {

    })






    //AJAX FUNCTIONS
    const clear_session = () => {
        //console.log("Sending request to clear session on the server...");
        talk("./ali_api/OpenAI_Handler.php", "CLEAR_SESSION", {pin:1492}, clear_session_handler);
    }
    const clear_session_handler = (operation, sent_data, return_data) => {
        //console.log(return_data);

    }
    //This function will cause the AI to ask the student a question
    const initiate_test = () => {
        let prompt = "You are an ESL instructor giving an oral interview to a student that will be used in a" +
            "placement test in an ESL program. You don't have any idea about the student's level. You will ask" +
            "a series of questions and based on the answers, try to determine the student's level. It should feel" +
            "like a natural conversation for the student. Polite. Professional. Begin with normal social connections " +
            "and proceed to harder questions. Base your subsequent questions on the level of the student's response. " +
            "If the student responds at a very high level, try asking more challenging questions. If they don't " +
            "seem to understand, ask easier questions. Invent a name for yourself. Briefly introduce yourself to the student and ask your first question for the student. Your first question should always be to ask their name. Also... use a male name for yourself.";
        prompt = "You are a new acquaintance just trying to get to know me. Ask me a series of questions to get to know me better. Ask me one question at a time and wait for my response before asking a new question. Act like a normal human being... respond to my response and express interest before asking the next question.";
        prompt = `You are a new acquaintance just trying to get to know me. Ask me a series of questions to get to know me better. Ask me one question at a time and wait for my response before asking a new question. Act like a normal human being... respond to my response and express interest before asking the next question.

            Important: After you generate the question, suggest how many seconds the student should have to respond verbally. It should be between 20 and 180 seconds. For simple questions, aim for 30 seconds. Vary it each time. 
            
            Return the result in this strict JSON format, without any extra words:
            
            {
              "question": "the question text",
              "suggested_time_in_seconds": 30
            }`;




        //console.log("Sending prompt to server:", prompt);

        let postData = {
            operation: "GET_TEXT_AND_SPEECH_RESPONSE",
            prompt: prompt,
            pin: "1492"
        }

        talk("./ali_api/OpenAI_Handler.php", "GET_TEXT_AND_SPEECH_RESPONSE", postData, initiate_test_handler);
    }
    const initiate_test_handler = (operation, sent_data, return_data) => {
        if(return_data['ERROR'] || return_data['text'] === "Failed to parse AI response properly.") {
            recover_from_ai_failed_to_parse_error()
            return;
        }


        setResponseText(return_data['text']);
        fetch_audio(return_data['audio_filename'])
        setQuestionTotalTime(return_data['response_seconds']);
        setQuestionTimeRemaining(return_data['response_seconds']);

        console.log(return_data);
    }
    const submit_student_response = (response_text) => {
        console.log("Sending prompt to server:", response_text);

        let postData = {
            operation: "GET_TEXT_AND_SPEECH_RESPONSE",
            prompt: response_text,
            pin: "1492"
        }

        talk("./ali_api/OpenAI_Handler.php", "GET_TEXT_AND_SPEECH_RESPONSE", postData, initiate_test_handler);
    }
    const submit_student_response_handler = () => {

    }



    const speech_to_text = () => {
        //console.log("Sending prompt to server:", prompt);

        let postData = new FormData();
        postData.append("operation", "EXTRACT_TEXT_FROM_SPEECH");
        postData.append("pin", "1492");
        postData.append("student_info", JSON.stringify({
            student_id: 1234545,
            user_and_test_id: 22
        }));
        postData.append("file", ALI_Recorder.get_blob(), "recording.webm");
        talk("./ali_api/OpenAI_Handler.php", "EXTRACT_TEXT_FROM_SPEECH", postData, speech_to_text_handler);
    }
    const speech_to_text_handler = (operation, sent_data, return_data) => {
        //console.log("In SpeechToTextHandler");
        if(return_data['error']) {
            setStudentTextResponse("ERROR: " + return_data['error']);
        } else {
            //setStudentTextResponse(return_data['response']);
            submit_student_response(return_data['response'])
        }

        //console.log(return_data);
    }





    //OTHER FUNCTIONS
    const fetch_audio = async (filename) => {
        //console.log(filename);

        // Generate the URL for the PHP script that streams audio
        // const url = '/ali_api/ALIAudioStreamer.php?filename=' + encodeURIComponent(filename) + "&t=" + Date.now();
        const url = '/ali_api/ALIAudioStreamer.php?filename=' + filename + "&t=" + Date.now();
        setAudioUrl(url);
    };
    const initialize_recorder = () => {
        if(isRecording) return;
        ALI_Recorder.init();
        console.log("Question Total Time: " + questionTotalTime);
        ALI_Recorder.startRecording(questionTotalTime);
        setNotificationMessage('Recording');
        setTestState('recording');
    }
    const stop_recording = () => {
        if(!isRecording) return;
        setTestState('thinking');
        ALI_Recorder.stopRecording();
        setNotificationMessage("Answering...");

    }
    const handle_ai_finished_talking = () => {
        initialize_recorder();
    }
    const recover_from_ai_failed_to_parse_error = () => {
        console.log("Recovering From AI Error");
    }



    //RENDERING
    return (
        <>
            {
                finishedLoggingIn ?
                    <>
                        {userId ?
                            <div className={TStyles.container}>
                                <h1 className={TStyles.title}>Test Name</h1>

                                <JsonViewer data={rubric} />

                                <SpeakingTestInterface
                                    state={testState}
                                    questionTotalTime={questionTotalTime}
                                    questionTimeRemaining={questionTimeRemaining}
                                />

                                {/*<div>*/}
                                {/*    <button onClick={() => setTestState('speaking')}>Set Speaking</button>*/}
                                {/*    <button onClick={() => setTestState('recording')}>Set Recording</button>*/}
                                {/*    <button onClick={() => setTestState('thinking')}>Set Thinking</button>*/}
                                {/*</div>*/}

                                <div className={TStyles.start_test_button_holder}>
                                    <button
                                        onClick={initiate_test}
                                        className={TStyles.start_test_button}
                                    >Start Conversation</button>
                                </div>

                                <div style={{"height":"400px"}}></div>

                                <div>{responseText}</div>

                                {/*<div*/}
                                {/*    className={TStyles.aiSpeakerImage}*/}
                                {/*>*/}
                                {/*    <img*/}
                                {/*        alt="AI Speaker"*/}
                                {/*        src={aiAnimationTransparent}*/}
                                {/*    />*/}
                                {/*</div>*/}


                                <div>
                                    {audioUrl && (
                                        <audio
                                            controls
                                            autoPlay
                                            id="audio_player"
                                            onEnded={handle_ai_finished_talking}
                                        >
                                            <source src={audioUrl} type="audio/mpeg" />
                                            Your browser does not support the audio tag.
                                        </audio>
                                    )}
                                </div>
                                <div className={notificationMessage === 'Processing' ? TStyles.processing_message : TStyles.student_recording_message}>
                                    {notificationMessage} {questionTimeRemaining ? questionTimeRemaining : ""}
                                </div>
                                {/*<div className={GenStyles.hidden}>*/}
                                {/*    <div>*/}
                                {/*        <button*/}
                                {/*            className={STTStyles.stt_button}*/}
                                {/*            onClick={initialize_recorder}*/}
                                {/*        >*/}
                                {/*            Start Recording Answer*/}
                                {/*        </button>*/}
                                {/*        <button*/}
                                {/*            className={STTStyles.stt_button}*/}
                                {/*            onClick={stop_recording}*/}
                                {/*        >*/}
                                {/*            Stop Recording*/}
                                {/*        </button>*/}
                                {/*    </div>*/}
                                {/*    <div>*/}
                                {/*        <textarea*/}
                                {/*            onChange={(event) => setStudentTextResponse(event.target.value)}*/}
                                {/*            value={studentTextResponse}*/}
                                {/*        >*/}

                                {/*        </textarea>*/}
                                {/*    </div>*/}
                                {/*    <div>*/}
                                {/*        <button*/}
                                {/*            className={STTStyles.stt_button}*/}
                                {/*            onClick={() => submit_student_response(studentTextResponse)}*/}
                                {/*        >Submit Response</button>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <div className={TStyles.container}>
                                    <button
                                        className={STTStyles.stt_button}
                                        onClick={clear_session}
                                    >
                                        Clear Session and Start Over
                                    </button>
                                </div>


                            </div>
                            : <LoginModule/>}
                    </> :
                    <div>loading</div>
            }
        </>
    )
}

export default TakeTestOld;
